import mergeWith from 'lodash/mergeWith';
import { Schema } from 'yup';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeDefaults: <Default, Data>(defaults: Default, data: Data) => any = (
  defaults,
  data
) => mergeWith({}, defaults, data, (defaultValue, value) => value ?? defaultValue);

export const stripValuesToSchema = <Values, TSchema>(values: Values, schema: Schema<TSchema>) => {
  if (!schema) return values;

  let strippedValues;

  try {
    strippedValues = schema.validateSync(values, {
      abortEarly: false,
      stripUnknown: true,
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    strippedValues = e.value;
  }

  return strippedValues;
};
